import React from 'react';
import { useTranslation } from 'react-i18next';
import CTA from "../../../components/Constant/cta/CTA";
import WhySection from "../../../components/WhySection/WhySection";
import IntroSection from "../../../components/IntroSection/IntroSection";
import FAQList from "../../../components/Constant/FAQCard/FAQCard";
import Testimonials from "../../../components/Constant/Testimonials/Testimonials";
import DetailsSection from "../../../components/DetailsSection/DetailsSection";
import InfoBlocks from "../../../components/InfoBlocks/InfoBlocks";
import ComparisonTable from "../../../components/ComparisonTable/ComparisonTable";
import SEO from "../../../utils/SEO";

export default function CyprusJurisdiction() {
    const { t } = useTranslation();
    const tp = (k, d) => t(`pages.cyprus-jurisdiction.${k}`, d);
    const obj = (k) => tp(k, { returnObjects: true });

    return (
        <main className='main'>
            <SEO
                title={tp('seo.title')}
                description={tp('seo.description')}
                keywords={tp('seo.keywords')}
                url="/cyprus-jurisdiction"
            />
            <IntroSection
                title={tp('intro.title')}
                subtitle={tp('intro.subtitle')}
                description={tp('intro.description')}
                badges={obj('intro.badges')}
                buttonText={tp('intro.button')}
                buttonLink="/quote"
                imageSrc={require("../../../assets/images/jurisdictions/cyprus.png")}
                imageAlt={tp('intro.imageAlt')}
            />

            <section className='section'>
                <div className="container">
                    <WhySection title={tp('why.title')} blocks={[{ items: obj('why.items') }]} />
                    <InfoBlocks title={tp('sectors.title')} blocks={obj('sectors.blocks')} />
                    <WhySection title={tp('benefits.title')} blocks={[{ items: obj('benefits.items') }]} />
                    <WhySection title={tp('challenges.title')} blocks={[{ items: obj('challenges.items') }]} />
                    <ComparisonTable
                        title={tp('comparison.title')}
                        columns={obj('comparison.columns')}
                        data={obj('comparison.rows')}
                    />
                    <DetailsSection title={tp('whyUs.title')} items={obj('whyUs.items')} />
                    <FAQList data={obj('faq.items')} title={tp('faq.title')} />
                    <Testimonials title={tp('testimonials.title')} testimonials={obj('testimonials.items')} />
                    <CTA
                        title={tp('cta.title')}
                        description={tp('cta.description')}
                        buttonText={tp('cta.button')}
                        buttonLink="/quote"
                    />
                </div>
            </section>
        </main>
    );
}
